import styled from '@emotion/styled'

export const FormStyles = styled.form`
  max-width: 22rem;
  .star-rating-container {
    margin: 1.5rem 0;
    .stars {
      display: flex;
      gap: 2rem;
      justify-content: start;
    }
  }

  .rating-label {
    margin-top: 1rem;
  }
`
